import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NormalButtom, ClearButtom } from './styles';

const propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  loading: PropTypes.bool,
  clear: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
  disable: PropTypes.bool,
};

const defaultProps = {
  title: 'Action',
  type: 'button',
  loading: false,
  clear: false,
  className: null,
  onClick: null,
};

export default function Button(props) {
  const {
    title,
    type,
    loading,
    clear,
    onClick,
    className,
    children,
    clickable = true,
    disable = false,
  } = props;

  // state
  const [buttonName, setButtonName] = useState();

  // handle click
  function handleClick(e) {
    if (loading) return;
    if (onClick) onClick(e);
  }

  // on change loading
  useEffect(() => {
    if (loading) {
      setButtonName('Aguarde...');
    } else {
      setButtonName(title);
    }
  }, [title, loading]);

  // renders
  function renderButtonName() {
    return loading ? (
      <span>
        {buttonName}
        <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }} />
      </span>
    ) : (
      <span>{buttonName}</span>
    );
  }

  // customizing props
  const customProps = {
    className,
    type,
    disabled: loading,
    clickable: clickable,
    disable: disable,
    onClick: handleClick,
  };
  // customizing inner content
  const innerContent = children || renderButtonName();

  return clear ? (
    <ClearButtom {...customProps}>{innerContent}</ClearButtom>
  ) : (
    <NormalButtom {...customProps}>{innerContent}</NormalButtom>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
